import React from 'react';
import { CheckCircle2, AlertTriangle } from 'lucide-react';

export function SplitSection({ id, title, description, challengeTitle, challengeDesc, solutionTitle, solutionItems = [] }) {
  return (
    <section id={id} className="relative w-full py-24 px-6 lg:px-16 bg-[#f8f4f0] text-[#1c1c1c] border-t border-black/5">
      <div className="max-w-7xl mx-auto w-full flex flex-col gap-16">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto flex flex-col items-center">
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6">
            {title}
          </h2>
          <p className="text-lg text-black/70 font-mono leading-relaxed">
            {description}
          </p>
        </div>

        {/* Split Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          
          {/* Challenge Card */}
          <div className="bg-white rounded-2xl p-10 shadow-xl shadow-red-900/5 border border-red-100 flex flex-col h-full">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center text-red-500">
                <AlertTriangle className="w-6 h-6" />
              </div>
              <h3 className="text-2xl font-bold text-red-950">{challengeTitle}</h3>
            </div>
            <p className="text-black/70 font-mono leading-relaxed text-lg flex-grow">
              {challengeDesc}
            </p>
          </div>

          {/* Solution Card */}
          <div className="bg-[#1c1c1c] text-[#f8f4f0] rounded-2xl p-10 shadow-2xl flex flex-col h-full relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
            
            <div className="flex items-center gap-4 mb-8 relative z-10">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-green-400 border border-white/20">
                <CheckCircle2 className="w-6 h-6" />
              </div>
              <h3 className="text-2xl font-bold">{solutionTitle}</h3>
            </div>
            
            <ul className="space-y-6 relative z-10 flex-grow">
              {solutionItems.map((item, idx) => (
                <li key={idx} className="flex items-start gap-4">
                  <div className="mt-1 w-2 h-2 rounded-full bg-green-400 flex-shrink-0" />
                  <p className="text-white/80 font-mono leading-relaxed">
                    {item}
                  </p>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}
